import { makeStyles } from "@material-ui/styles"

const useStyle = makeStyles(() => ({
  input: {
    maxWidth: "62px !important",
  }
}));

export default useStyle;